import React from 'react'

import { locationToEndpoint } from '../../../../src/utils/location.js'
import { widgetEnum } from '../../../../utils/constants.js'

import PinnedIcon from './PinnedIcon.jsx'
import ReturnButtonDesktop from './ReturnButtonDesktop.jsx'
import ReturnButtonMobile from './ReturnButtonMobile.jsx'

function create (app, config) {
  let location = null

  const returnPhysicalLocation = async () => {
    if (location) {
      const { lat, lng, ordinal, floorId, pinTitle, structureId } = location
      return {
        title: pinTitle,
        lat,
        lng,
        ordinal,
        isPhysicalLocation: true,
        isPinned: true,
        floorId,
        structureId,
        responseOrder: 20
      }
    }
  }

  app.bus.on('user/getPhysicalLocation', returnPhysicalLocation)

  const init = async () => {
    if (config.location) {
      location = config.location ? await locationToEndpoint(app, config.location) : null
      if (location) {
        const { lat, lng, ordinal, floorId } = location
        location.pinTitle = config.location.pinTitle || location.title

        app.bus.send('map/addMarker', {
          id: 'pinnedLocation',
          ordinal,
          lat,
          lng,
          markerComponent: <PinnedIcon />,
          markerOptions: { anchor: 'bottom' }
        })

        // if we have a physical location, set the search "from" to reflect it
        returnPhysicalLocation()
          .then(loc => {
            if (loc)
              app.bus.send('online/resetSearchInputData', { usePhysicalLocation: true })
          })

        const returnButtonClicked = () => app.bus.send('map/animateToPoint', { lat, lng, floorId, zoom: config.zoom || 20 })

        const focusAtStart = config.focusAtStart === undefined ? true : config.focusAtStart // defalut to true
        if (focusAtStart)
          setTimeout(returnButtonClicked, 1000) // on initialization, zoom the map to the pinned location

        // register the "return to physical location" button
        app.bus.send('layers/register', {
          id: 'pinnedLocation/returnButtonDesktop',
          widget: () => <ReturnButtonDesktop T={app.gt()} isHome={true} onClick={returnButtonClicked} />,
          layoutId: 'buttonOptions',
          isOverlay: true,
          widgetType: widgetEnum.Desktop,
          show: true,
          order: 5
        })

        app.bus.send('layers/register', {
          id: 'pinnedLocation/returnButtonMobile',
          widget: () => <ReturnButtonMobile T={app.gt()} isHome={true} onClick={returnButtonClicked} />,
          layoutId: 'mapControls',
          isOverlay: true,
          widgetType: widgetEnum.Mobile,
          show: true,
          order: 5
        })
      }
    }
  }

  return {
    init,
    internal: {
      returnPhysicalLocation
    }
  }
}

export {
  create
}
